import React from "react";
import { Shield, Heart, Umbrella, Users, Briefcase, Car } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Tiefbau & Fundamente",
  description: ".Im Bereich Tiefbau und Fundamentarbeiten schaffen wir die Grundlage für jedes Bauprojekt. Von der präzisen Vorbereitung des Baugrunds bis zur fachgerechten Ausführung aller Erd- und Gründungsarbeiten legen wir besonderen Wert auf Stabilität, Genauigkeit und eine saubere Umsetzung. Jedes Projekt wird individuell geplant und entsprechend den örtlichen Gegebenheiten umgesetzt, um langfristig sichere und belastbare Ergebnisse zu gewährleisten.",
  icon: Shield
}, {
  title: "Erdarbeiten & Aushub",
  description: "Erdarbeiten und Aushub bilden die Grundlage jedes Bauvorhabens. Wir übernehmen sämtliche Arbeiten rund um das Bewegen, Abtragen und Vorbereiten von Boden – präzise, effizient und abgestimmt auf die Anforderungen des jeweiligen Projekts. Dabei achten wir auf eine fachgerechte Ausführung, die sowohl die Tragfähigkeit des Untergrunds als auch einen reibungslosen Bauablauf sicherstellt.",
  icon: Heart
}, {
  title: "Außenanlagen",
  description: "Außenanlagen sind die Visitenkarte jedes Grundstücks.\nWir gestalten und realisieren funktionale und optisch ansprechende Außenbereiche – abgestimmt auf Ihre Wünsche und die Gegebenheiten vor Ort.\n\n\nVon der ersten Planung bis zur fertigen Umsetzung sorgen wir für saubere, langlebige und durchdachte Lösungen rund um Ihr Grundstück.",
  icon: Umbrella
}, {
  title: "Pflasterbau&Garten",
  description: "Pflasterarbeiten verbinden Funktionalität mit einer sauberen und ansprechenden Optik.\nWir realisieren Einfahrten, Wege und Terrassen fachgerecht und präzise – abgestimmt auf die Anforderungen des jeweiligen Grundstücks.\n\n\nDabei legen wir großen Wert auf eine stabile Ausführung und ein gleichmäßiges, hochwertiges Erscheinungsbild.",
  icon: Users
}, {
  title: "Kanalbau",
  description: "Kanalarbeiten sind ein zentraler Bestandteil der Infrastruktur und erfordern präzise Planung sowie fachgerechte Ausführung.\nWir übernehmen sämtliche Arbeiten im Bereich Kanalbau – von der Verlegung neuer Leitungen bis zur Erneuerung bestehender Systeme.\n\n\nDabei achten wir auf eine zuverlässige Umsetzung, die langfristig eine sichere Entwässerung und Funktion gewährleistet.",
  icon: Briefcase
}, {
  title: "Abbruch",
  description: "Abbrucharbeiten erfordern Erfahrung, Planung und eine kontrollierte Durchführung. Wir übernehmen den fachgerechten Abbruch von Gebäuden und Bauteilen – sicher, effizient und abgestimmt auf die jeweiligen Gegebenheiten vor Ort. Dabei sorgen wir für einen strukturierten Ablauf und eine saubere Vorbereitung für nachfolgende Bauarbeiten.",
  icon: Car
}, {
  title: "Außenanlagen",
  description: "Wir gestalten Ihre Außenanlagen professionell und nachhaltig. Von der Planung bis zur Umsetzung sorgen wir für ein harmonisches Gesamtbild, das Ästhetik und Funktionalität perfekt vereint.",
  icon: Umbrella
}];
export default function UnsereKernkompetenzen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="32455" id="unsere-kernkompetenzen" className="py-24 relative overflow-hidden !text-[hsl(43,96%,56%)] !bg-[hsl(46,97%,65%)]" ref={ref}>
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="text-center mb-20 transition-all duration-700 transform opacity-100 translate-y-0 !text-[hsl(0,0%,100%)]">
          
          <h3 className="text-5xl font-extrabold mb-6 tracking-tighter font-sans !text-[hsl(0,74%,42%)]">
            Unsere Kernkompetenzen
          </h3>
          <p className="max-w-2xl mx-auto text-lg !text-[hsl(0,0%,0%)] !bg-[hsl(0,0%,100%)] !font-bold !font-mono">Als Ihr regionaler Partner für Tiefbau und Erdarbeiten bieten wir spezialisierte Lösungen mit industrieller Präzision und handwerklicher Leidenschaft.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {services.map((service, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="text-card-foreground flex flex-col gap-6 py-6 h-full border border-border rounded-sm transition-all duration-300 group !bg-[hsl(0,0%,100%)] hover:border-primary/50 hover:shadow-xl">
                <CardHeader className="pb-4">
                  <div className="w-16 h-16 rounded-sm bg-accent flex items-center justify-center mb-6 group-hover:bg-primary group-hover:shadow-[0_0_20px_rgba(249,115,22,0.4)] transition-all duration-300">
                    <service.icon className="w-8 h-8 text-secondary group-hover:text-primary-foreground transition-colors duration-300" />
                  </div>
                  <CardTitle className="leading-none font-bold group-hover:text-primary transition-colors duration-300 font-sans !text-[hsl(0,74%,42%)] !text-4xl">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground leading-relaxed !text-[hsl(0,0%,0%)] !font-bold !not-italic !font-mono !text-base">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}